import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-flex-css',
  templateUrl: './flex-css.component.html',
  styleUrls: ['./flex-css.component.css']
})
export class FlexCssComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }

}
